import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import Hero, { HeroProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/hero';

interface Props {
  data: any;
}

const HeroTastic = ({ data }: Props) => {
  const fields = data.data.dataSource.fields;

  return (
    <Hero
      look={CHIPOTLE_CONTENT_LOOK}
      image={fields.image.fields.file.url}
      title={fields.title}
      titleColor={fields.titleColor}
      subtitle={fields.subtitle}
      subtitleColor={fields.subtitleColor}
      ctaLabel={fields.ctaLabel}
      ctaReference={fields.ctaReference}
      buttonBackgroundColor={fields.buttonBackgroundColor}
      buttonBackgroundColorHover={fields.buttonBackgroundColorHover}
      buttonBackgroundTransparent={fields.buttonBackgroundTransparent}
      buttonBorderRadius={fields.buttonBorderRadius}
      buttonHorizontalAlign={fields.buttonHorizontalAlign}
      buttonVerticalAlign={fields.buttonVerticalAlign}
      buttonTextColor={fields.buttonTextColor}
    />
  );
};

export default HeroTastic;
